import * as RouteScreens from "./routes";
import { ROUTE_PATH } from "./routePath";

export const routes = [
  {
    path: ROUTE_PATH.home,
    element: RouteScreens.Home,
  },
];
